/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('cart-item-key');
      const addOnProductList = $(this).data('cart-item-add-on');
      let itemsAddon = {};
      itemsAddon[lineID] = 0;
      $(this).parents('.cart__item-list').find('.cart__card').each(function( index ) {
        if(addOnProductList == $(this).data('cart-item-add-on') && $(this).find(".cart__remove-btn").length == 0) {
          let quantityProduct = 0;
          let lineItem = $(this).data('cart-item');
          itemsAddon[lineItem] = quantityProduct;
        }
      });
      window.PXUTheme.jsCart.removeFromCart(itemsAddon);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (itemsAddon) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
       updates: itemsAddon
      },
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsCart.updateView(cart);
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart) {
    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {
          $('.cart__item-list').replaceWith($(html).find('.cart__item-list'));
          $('[data-bind="itemCount"]').text(cart.item_count);
        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;